module.exports = __webpack_public_path__ + "media/product/week-2-79506724.png";